import { DateTime } from 'luxon';

export function duration(time1: string | Date, time2: string | Date): string {
    if (!time1 || !time2) {
        return '';
    }

    const dateTime1 = DateTime.fromJSDate(time1 instanceof Date ? time1 : new Date(time1));
    const dateTime2 = DateTime.fromJSDate(time2 instanceof Date ? time2 : new Date(time2));

    if (dateTime1 < dateTime2) {
        return dateTime2.diff(dateTime1).toFormat('-d.hh:mm:ss');
    } else {
        return dateTime1.diff(dateTime2).toFormat('d.hh:mm:ss');
    }
}
